import { ChevronRightIcon, HomeIcon } from "@heroicons/react/20/solid";
import Link from "next/link";

const Breadcrumb = ({ pageTitle }: { pageTitle?: string }) => {
  return (
    <nav className="flex mb-4" aria-label="Breadcrumb">
      <ol role="list" className="flex items-center space-x-4">
        <li>
          <div>
            <Link href="/" className="text-gray-400 hover:text-gray-500">
              <HomeIcon className="h-5 w-5 flex-shrink-0" aria-hidden="true" />
              <span className="sr-only">Home</span>
            </Link>
          </div>
        </li>

        <li>
          <div className="flex items-center">
            <ChevronRightIcon
              className="h-5 w-5 flex-shrink-0 text-gray-400"
              aria-hidden="true"
            />
            <Link
              href="/sop/examples"
              className="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700 line-clamp-1"
            >
              SOP Templates
            </Link>
          </div>
        </li>

        {pageTitle && (
          <li>
            <div className="flex items-center">
              <ChevronRightIcon
                className="h-5 w-5 flex-shrink-0 text-gray-400"
                aria-hidden="true"
              />
              <p className="ml-4 text-sm font-medium text-gray-700 line-clamp-1">
                {pageTitle}
              </p>
            </div>
          </li>
        )}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
